import kcloudKnackutil from '@kuraemon/kcloud-knackutil'

/** knackRevisionを返す */
export const getKnackRevision = () => (kcloudKnackutil.knackRevision);

/** 一般土木 要領番号 */
const generalCivilWorkKnack = kcloudKnackutil.getKnackTypeDefs().find((knackTypeDef) => knackTypeDef.isGeneralCivilWork);
if (!generalCivilWorkKnack) throw new Error("no generalCivilWorkKnack def");
export const generalCivilWorkKnackId = kcloudKnackutil.getKnackDefsByKnackType(generalCivilWorkKnack.knackType)[0].knackId;

/** 一般建築 要領番号 */
const generalBuildingKnack = kcloudKnackutil.getKnackTypeDefs().find((knackTypeDef) => knackTypeDef.isGeneralBuilding);
if (!generalBuildingKnack) throw new Error("no generalBuildingKnack def");
export const generalBuildingKnackId = kcloudKnackutil.getKnackDefsByKnackType(generalBuildingKnack.knackType)[0].knackId;

/** 電子納品の選択値 */
export const electronicDelivery = -1;

/**
 * 国交省営繕対応のknack_idかどうかを返す
 * @param knackId 
 * @returns 
 */
export const isMlitKnackId = (knackId: number) => {
  const knackDef = kcloudKnackutil.searchKnackDefByKnackId(knackId)
  if (!knackDef) { return false }
  return kcloudKnackutil.getKnackTypeDefByKnackType(knackDef.knackType).isMlitRepair
}

/**
 * 日本下水道事業団のknack_idかどうかを返す
 * @param knackId 
 * @returns 
 */
export const isJswaKnackId = (knackId: number) => {
  const knackDef = kcloudKnackutil.searchKnackDefByKnackId(knackId)
  if (!knackDef) { return false }
  return kcloudKnackutil.getKnackTypeDefByKnackType(knackDef.knackType).isJswa
}

/**
 * 一般土木のknack_idかどうかを返す
 * @param knackId 
 * @returns 
 */
export const isGeneralCivilWorkKnackId = (knackId: number) => {
  const knackDef = kcloudKnackutil.searchKnackDefByKnackId(knackId)
  if (!knackDef) { return false }
  return kcloudKnackutil.getKnackTypeDefByKnackType(knackDef.knackType).isGeneralCivilWork
}

/**
 * 一般建築のknack_idかどうかを返す
 * @param knackId 
 * @returns 
 */
export const isGeneralBuildingKnackId = (knackId: number) => {
  const knackDef = kcloudKnackutil.searchKnackDefByKnackId(knackId)
  if (!knackDef) { return false }
  return kcloudKnackutil.getKnackTypeDefByKnackType(knackDef.knackType).isGeneralBuilding
}

/**
 * NEXCOのknack_idかどうかを返す
 * @param knackId 
 * @returns 
 */
export const isNexcoKnackId = (knackId: number): boolean => {
  const knackDef = kcloudKnackutil.searchKnackDefByKnackId(knackId)
  if (!knackDef) { return false }
  return kcloudKnackutil.getKnackTypeDefByKnackType(knackDef.knackType).isNexco
}

/**
 * 要領タイプ一覧を返す
 * @returns 要領タイプ一覧
 */
export const getKnackTypeMap = () => {
  return kcloudKnackutil.getKnackTypeDefs().map((d) => ({
    knackType: d.knackType,
    _category: d.category,
    title: d.title,
  }));
}

/**
 * 指定された要領タイプの要領一覧を返す
 * @param knackType 要領タイプ
 * @returns 要領一覧
 */
export const getKnacksByType = (knackType: number) => {
  return kcloudKnackutil.getKnackDefsByKnackType(knackType).map((d) => ({
    knackType: d.knackType,
    ...('group' in d ? { group: d.group } : {}),
    knackId: d.knackId,
    _knackName: d.knackName,
    ...(d.wareki != null ? { wareki: d.wareki } : {}),
    ...(d.jyunkyoYouryou1 != null ? { jyunkyoYouryou1: d.jyunkyoYouryou1 } : {}),
    ...(d.jyunkyoYouryou2 != null ? { jyunkyoYouryou2: d.jyunkyoYouryou2 } : {}),
  }))
}

/**
 * 大分類選択ダイアログを表示するknack_idかどうかを返す
 * @param knackId 
 * @returns 
 */
 export const isBroadCategorySelect = (knackId: number) => {
  if(isGeneralBuildingKnackId(knackId)) return false;
  if(isGeneralCivilWorkKnackId(knackId)) return false;
  if(isMlitKnackId(knackId)) return false;
  if(isJswaKnackId(knackId)) return false;
  return true;
}

/**
 * KnackType constants for MLIT electronic delivery
 */
export const MLIT_KNACK_TYPE = {
  /** MLIT電子納品 タイプ1 - MLIT construction projects type 1 */
  ELECTRONIC_DELIVERY_TYPE_1: 1,
  /** MLIT電子納品 タイプ2 - MLIT construction projects type 2 */ 
  ELECTRONIC_DELIVERY_TYPE_2: 2,
  /** 電子納品（営繕）タイプ3 - MLIT construction projects type 3 */ 
  ELECTRONIC_DELIVERY_MAINTENANCE_TYPE_3: 3
} as const

/**
 * 国交省電子納品要領のknack_idかどうかを返す
 * knackType 1と2がMLIT電子納品要領に対応
 * @param knackId 
 * @returns boolean
 */
export const isMlitElectronicDeliveryKnackId = (knackId: number): boolean => {
  const knackDef = kcloudKnackutil.searchKnackDefByKnackId(knackId)
  if (!knackDef) { return false }
  return knackDef.knackType === MLIT_KNACK_TYPE.ELECTRONIC_DELIVERY_TYPE_1 || 
         knackDef.knackType === MLIT_KNACK_TYPE.ELECTRONIC_DELIVERY_TYPE_2
}

/**
 * 引数に対応するorganize_info_treeを返す
 * @param knackId 
 * @param constructionName 
 * @param broadCategory 
 * @returns 
 */
export const organizeInfoTreeFor = (knackId: number, constructionName: string, broadCategory: string) => {
  // 一般建築
  if(isGeneralBuildingKnackId(knackId)) return;

  // 一般土木
  if(isGeneralCivilWorkKnackId(knackId)){
    return {
      t: 0,
      v: constructionName, // 工事名称
      c: [
        {
          t: 1,
          v: '工事', // 大分類 固定値
          c: [] // 空 固定値
        }
      ]
    };
  }

  // 電子納品（営繕）
  if(isMlitKnackId(knackId)) return;
  // 日本下水道事業団 営繕 と同じ
  if(isJswaKnackId(knackId)) return;

  // 電子納品（営繕以外）
  return {
    t: 0,
    v: constructionName, // 工事名称
    c: [
      {
        t: 1,
        v: broadCategory, // 大分類
        c: [] // 空 固定値
      }
    ]
  };
}

/**
 * トークに渡すURLを作って返す.
 * @param talkLinkBaseUrl 
 * @param returnKcloudPath 
 * @returns 
 */
export const talkLinkUrlFor = (talkLinkBaseUrl: string, returnKcloudPath: string) => {
  if (!talkLinkBaseUrl) return ''
  try {
    if (returnKcloudPath) {
      // トークから戻ってくるurlをqueryを追加する
      const queryDelemiter = talkLinkBaseUrl.includes('?') ? '&' : '?';
      const returnKcloudUrl = `${import.meta.env.VITE_APP_KCLOUD_URL}${returnKcloudPath}`
      return `${talkLinkBaseUrl}${queryDelemiter}return_kcloud_url=${encodeURIComponent(returnKcloudUrl)}`
    }
    return talkLinkBaseUrl;
  } catch (ignore) {
    console.warn(ignore)
    return ''
  }
}
